export default __webpack_public_path__ + "static/media/ic_no_foto.73cafe45.svg";